import { makeObservable, observable, action } from 'mobx';

export type MusicType =
  | 'electronicDance'
  | 'hipHop'
  | 'rock'
  | 'pop'
  | 'trap'
  | 'beats'
  | 'rnbSoul'
  | 'other';

export class MusicStore {
  selelctedMusic: Set<MusicType> = new Set();

  constructor() {
    makeObservable(this, {
      selelctedMusic: observable,
      toggleMusic: action,
    });
  }

  toggleMusic(inputMusic: MusicType) {
    if (this.selelctedMusic.has(inputMusic)) {
      this.selelctedMusic.delete(inputMusic);
    } else {
      this.selelctedMusic.add(inputMusic);
    }
  }
}

export const musicStore = new MusicStore();
